import { makeStyles } from "@mui/styles";

export default makeStyles(
  ({ palette, boxShadows, functions, transitions, breakpoints, typography }) => {
    const { dark, white, text } = palette;
    const { navbarBoxShadow } = boxShadows;
    const { pxToRem } = functions;
    const { size } = typography;

    return {
      navbar: {
        boxShadow: navbarBoxShadow,
        backgroundColor: white.main,

        color: ({ transparentNavbar, light }) => {
          let color;

          if (light) {
            color = white.main;
          } else if (transparentNavbar) {
            color = text.main;
          } else {
            color = dark.main;
          }

          return color;
        },
        top: ({ absolute }) => (absolute ? 0 : pxToRem(0)),
        minHeight: pxToRem(75),
        display: "grid",
        alignItems: "center",
        paddingTop: pxToRem(8),
        paddingBottom: pxToRem(8),
        paddingRight: ({ absolute }) => (absolute ? pxToRem(8) : 0),
        paddingLeft: ({ absolute }) => (absolute ? pxToRem(16) : 0),

        "& > *": {
          transition: transitions.create("all", {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },

        "& .MuiToolbar-root": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          Position:"relative !important",
          padding: `${pxToRem(4)} ${pxToRem(0)}`,

          [breakpoints.up("sm")]: {
            minHeight: "auto",
          },
        },
      },
      sidenav_logo: {
        width: '80%',
        marginRight: "1rem",
      },
      navbar_container: {
        flexDirection: "row",
        alignItems: "flex-start",
        paddingTop: pxToRem(4),
        paddingBottom: pxToRem(4),

        [breakpoints.up("md")]: {
          flexDirection: "row",
          alignItems: "center",
          paddingTop: "0",
          paddingBottom: "0",
        },
      },

      navbar_row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",

        [breakpoints.up("md")]: {
          justifyContent: ({ isMini }) => (isMini ? "space-between" : "stretch"),
          width: ({ isMini }) => (isMini ? "100%" : "max-content"),
        },

        [breakpoints.up("xl")]: {
          justifyContent: "stretch !important",
          width: "max-content !important",
        },
      },
      navbar_section_desktop: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& .userName": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textDecoration: "none",
          fontWeight: 600,
          textTransform: "capitalize",
        },
      },
      avatar_container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        position:"relative"
      },

      navbar_icon_button: {
        padding: `0 ${pxToRem(6)}`,

        "& .material-icons, .material-icons-round": {
          fontSize: `${size.regular} !important`,
        },

        "& .MuiTypography-root": {
          display: "block",

          [breakpoints.up("sm")]: {
            display: "inline-block",
            lineHeight: 1.2,
            marginLeft: pxToRem(4),
          },
        },
      },

      // navbar_mobile_menu: {
      //   display: "inline-block",
      //   padding: "6px 5px 0",

      //   [breakpoints.up("xl")]: {
      //     display: "none",
      //   },
      // },

      navbar_input: {
        "& .material-icons, .material-icons-round": {
          color: text.main,
        },
      },
    };
  }
);
